<template>
  <div>
    <v-autocomplete
      :disabled="disabled"
      :items="optionList"
      :rules="ruleList"
      outlined
      v-model="value"
      v-if="optionList"
    ></v-autocomplete>
    <p v-else>No subcategories for this item!</p>
  </div>
</template>

<script>
import formElementMixin from "./formElementMixin";

export default {
  computed: {
    itemList() {
      return this.$store.state[this.optionConfig.entityName].list;
    },
    item() {
      if (!this.attributeMap) {
        return;
      }
      const id = this.attributeMap[this.optionConfig.attributeContainingId];
      return this.$store.getters[`${this.optionConfig.entityName}/getById`](id);
    },
    optionList() {
      if (!this.item) {
        return;
      }
      return this.item[this.optionConfig.entityEnumAttribute];
    },
  },
  async created() {
    await this.$store.dispatch(`${this.optionConfig.entityName}/list`, {
      reload: false,
    });
  },
  methods: {
    clearValueIfInvalidOption() {
      const { optionList, value } = this;

      if (Array.isArray(optionList) && !optionList.includes(value)) {
        this.value = null;
      }
    },
  },
  props: {
    optionConfig: {
      required: true,
      type: Object,
      validator: function (optionConfig) {
        if (!optionConfig) {
          return false;
        }

        return Object.keys(optionConfig).every(attribute =>
          [
            "attributeContainingId",
            "entityName",
            "entityEnumAttribute",
          ].includes(attribute)
        );
      },
    },
  },
  watch: {
    optionList() {
      this.clearValueIfInvalidOption();
    },
  },
  mixins: [formElementMixin],
};
</script>
